module.exports = __webpack_public_path__ + "img/ico_delivery_sort_parcel.ea42236.png";